import { ReactNode, useEffect, useState } from "react";
import appStateConfig from "./appStateConfig";
import AppStateContext from "./AppStateContext";
import IAppSessionState from "./IAppSessionState";

export interface IAppStateProvider {
  children: ReactNode;
}

const defaultSessionState: IAppSessionState = {
  isLogin: false,
  userId: null,
  personId: null,
  expiration: null,
  roles: [],
  token: null,
};

const AppStateProvider = (props: IAppStateProvider) => {

  const [sessionState, _setSessionState_] = useState(defaultSessionState);
  const [loadingSessionState, setLoadingSessionState] = useState(true);

  
  const clearSession = () => {
    localStorage.removeItem(appStateConfig.tokenStorageKey);
    localStorage.removeItem(appStateConfig.sessionStorageKey);
    _setSessionState_(defaultSessionState);
  };

  useEffect(() => {
    const loadedSessionJson = localStorage.getItem(appStateConfig.sessionStorageKey);
    if (loadedSessionJson == null) {
      setLoadingSessionState(false);
      return;
    }
    const loadedSession = JSON.parse(loadedSessionJson) as IAppSessionState;

    if (loadedSession.expiration == null || (new Date(loadedSession.expiration) < new Date())) {
      clearSession();
      setLoadingSessionState(false);
      return;
    }

    _setSessionState_(loadedSession);
    setLoadingSessionState(false);
  }, []);

  useEffect(() => {
    setLoadingSessionState(false);
  }, []);

  const setSessionState = (sessionState: IAppSessionState) => {
    localStorage.setItem(appStateConfig.tokenStorageKey, sessionState.token!);
    localStorage.setItem(appStateConfig.sessionStorageKey, JSON.stringify(sessionState));
    _setSessionState_(sessionState);
  };

  return (
    <AppStateContext.Provider value={{
      sessionState,
      loadingSessionState,
      setSessionState,
      clearSession,
    }}>
      {props.children}
    </AppStateContext.Provider>
  );
};

export default AppStateProvider;
